import { getAugmentedNamespace } from './_commonjsHelpers.js';
import * as index from '../node_modules/@mui/utils/deepmerge/index.js';

var require$$4 = /*@__PURE__*/getAugmentedNamespace(index);

export { require$$4 as default };
